import axios from "axios";
import { toast } from "react-toastify";

export const addVote = async (userId, goalId, token) => {
  try {
    const data = {
      userId,
      goalId,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/clubs/voteGoal`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(`Error while adding vote: ${error.response.data}`);
      // throw new Error(error.response.data.message);
    } else {
      toast.error(`Error while adding vote: ${error.message}`);
      // throw new Error(error.message);
    }
  }
};
